<template>
  <div class="banners">
    <div class="jianbian">
      <div style="width: 1200px; margin: 0 auto">
        <img
          src="../../assets/img/banner_zhnp@2x.png"
          alt=""
          class="banners_img"
        />
      </div>
    </div>
    <div class="solution_nav" ref="aaa">
      <router-link
        v-for="(item, index) in Wisdommarketrot"
        :key="index"
        :to="(item.path = '' ? '' : item.path)"
        ><div
          :class="{ active: $store.state.solution == index }"
          @click="aaa(index)"
        >
          {{ item.name }}
        </div></router-link>
    </div>
    <router-view />
  </div>
</template>
<script>
export default {
  data() {
    return {
      Wisdommarketrot: [
        {
          path: "/solution/Wisdommarket",
          name: "智慧农批",
        },
        // {
        //   path: "",
        //   name: "智慧农贸",
        // },
        {
          path: "/solution/Payplatform",
          name: "支付结算平台",
        },
        {
          path: "/solution/Loadometer",
          name: "地磅无人值守",
        },
      ],
    };
  },
  created() {
    this.$store.commit("solutions", -1);
    if (this.$route.path == "/solution/Wisdommarket") {
      this.$store.commit("solutions", 0);
    }
    // else if (this.$route.path == "/solution/Smarttrade") {
    //   this.$store.commit("solutions", 1);
    // }
    else if (this.$route.path == "/solution/Payplatform") {
      this.$store.commit("solutions", 1);
    }else if (this.$route.path == "/solution/Loadometer") {
      this.$store.commit("solutions", 2);
    }
  },
  methods: {
    aaa(index) {
      this.$store.commit("solutions", index);
    },
  },
};
</script>
<style  scoped>
.banners_img {
  width: 1200px;
  height: 599px;
  margin: 0 auto;
}
.solution_nav {
  width: 496px;
  height: 224px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.solution_nav a div {
  height: 40px;
  padding-left: 18px;
  padding-right: 18px;
  display: block;
  line-height: 40px;
  text-align: center;
  background: #f7fbff;
  border-radius: 23px;
  border: 1px solid #1958c4;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1958c4;
}

.solution_nav a div:hover {
  background: #1958c4;
  color: #ffffff;
}
.active {
  background: #1958c4 !important;
  color: #ffffff !important;
}
.jianbian{
    width: 100%;
/* background: linear-gradient(to right #154AC3, #1B329A ); */
 background: linear-gradient(to  right, #154AC3, #1B329A);
  /* background: linear-gradient(to bottom right, #154AC3 , #1B329A); */
}
</style>>


